import { PropTypes } from 'react';
import { ContentType, ContentStatus, SourceType } from 'enums';

const { string, number, bool, array, object, shape, oneOf, arrayOf, oneOfType } = PropTypes;

const contentStatuses = Object.keys(ContentStatus).map(key => ContentStatus[key]);

export const bootstrapPropTypes = shape({
    version: string,
    env: string,
    bam: shape({
        sdkHost: string,
        env: string,
        playerVersion: string
    }),
    player: shape({
        logos: object
    }),
    syndicatedPlayer: shape({
        gatedAll: bool,
        gatedIE: bool
    }),
    preRoll: shape({
        editions: object
    }),
    adobePass: shape({
        preauthorizeNetworks: array,
        preauthorizeNetworksEnabled: bool
    })
});

export const entitlementsPropTypes = shape({
    entitled: bool
});

export const packagesPropTypes = array;

export const sourcePropTypes = shape({
    id: string,
    name: string,
    type: oneOf(Object.keys(SourceType).map(key => SourceType[key])),
    origination: string
});

export const linksPropTypes = shape({
    play: string,
    web: string
});

export const streamPropTypes = shape({
    id: string,
    name: string,
    status: oneOf(contentStatuses),
    duration: string,
    entitlements: entitlementsPropTypes,
    packages: packagesPropTypes,
    source: sourcePropTypes,
    score: number,
    authTypes: array,
    adobeRSS: string,
    links: linksPropTypes,
    blackoutText: string
});

export const eventPropTypes = shape({
    type: string,
    gameState: string,
    teamOneName: string,
    teamTwoName: string,
    teamTwoRank: number,
    teamOneScore: string,
    teamTwoScore: string,
    teamOneIsWinner: bool,
    teamTwoIsWinner: bool,
    statusTextOne: string
});

// product content id is currently number
export const contentPropTypes = shape({
    id: oneOfType([string, number]),
    guid: string,
    type: oneOf(Object.keys(ContentType).map(key => ContentType[key])),
    status: oneOf(contentStatuses),
    name: string,
    subtitle: string,
    imageHref: string,
    date: string,
    shortDate: string,
    utc: string,
    time: string,
    score: number,
    streams: arrayOf(streamPropTypes),
    event: eventPropTypes,
    description: string,
    iconHref: string,
    blackoutText: string,
    // To be added
    duration: string
});

export const bucketMetadataPropTypes = shape({
    totalCount: number,
    displayCount: number,
    scored: bool,
    grouped: bool
});

export const bucketLinksPropTypes = shape({
    self: string,
    web: string
});

export const bucketPropTypes = shape({
    id: number,
    name: string,
    type: string,
    style: string,
    metadata: bucketMetadataPropTypes,
    links: bucketLinksPropTypes,
    contents: arrayOf(contentPropTypes)
});

export default {
    bootstrap: bootstrapPropTypes,
    source: sourcePropTypes,
    links: linksPropTypes,
    stream: streamPropTypes,
    content: contentPropTypes,
    bucketMetadata: bucketMetadataPropTypes,
    bucketLinks: bucketLinksPropTypes,
    bucket: bucketPropTypes
};



// WEBPACK FOOTER //
// ./app/common/PropTypes.js